import React from "react";
import { Barras, COLORES, Kpis, Mezcla, Pagina, Tabla, Tarjeta, fmtM, fmtN, useDatos } from "./comun";

const ESTADO = { Sano: "success", "Por agotarse": "warning", Sobreinventario: "warning", "Sin venta": "secondary", Agotado: "danger" };

function ReporteInventario() {
  const { datos: d, error } = useDatos("/inventario");
  const k = d?.kpis;
  return (
    <Pagina titulo="Inventario" subtitulo="Cuanto vino hay, cuanto vale y que tan rapido sale" error={error} cargando={!d}>
      {d && <>
        <Kpis items={[
          { t: "Botellas", v: fmtN(k.botellas), d: `${fmtN(k.cajas)} cajas` }, { t: "Valor a costo", v: fmtM(k.valor) }, { t: "Valor a venta", v: fmtM(k.valorVenta) },
          { t: "Por agotarse", v: fmtN(k.porAgotarse), d: "Menos de 30 dias" }, { t: "Sobreinventario", v: fmtN(k.sobreinventario), d: "Mas de 240 dias" }, { t: "Agotados", v: fmtN(k.agotados) },
        ]} />
        <div className="rp-grid">
          <Tarjeta titulo="Valor por tipo de vino"><Mezcla datos={d.porTipo} valor="valor" /></Tarjeta>
          <Tarjeta titulo="Salud del inventario" nota="Numero de vinos"><Barras datos={d.estados} valor="valor" fmt={fmtN} /></Tarjeta>
          <Tarjeta titulo="Valor por region"><Barras datos={d.porRegion} valor="valor" extra={(x) => `${fmtN(x.botellas)} bot.`} /></Tarjeta>
          <Tarjeta titulo="Valor por añada"><Barras datos={d.porAnada} valor="valor" color={COLORES[1]} extra={(x) => `${fmtN(x.botellas)} bot.`} /></Tarjeta>
          <Tarjeta titulo="Rotacion por vino" nota="Dias de inventario con la venta de los ultimos 90 dias" ancho>
            <Tabla filas={d.detalle} columnas={[
              { t: "Vino", k: "vino" }, { t: "Tipo", k: "tipo" }, { t: "Existencia", k: "existencia", f: fmtN, n: 1 }, { t: "Vendidas 90 dias", k: "vendidas90", f: fmtN, n: 1 },
              { t: "Dias de inventario", k: "diasInventario", f: (v) => (v === null ? "-" : fmtN(v)), n: 1 }, { t: "Por recibir", k: "porRecibir", f: fmtN, n: 1 }, { t: "Valor", k: "valor", f: fmtM, n: 1 },
              { t: "Estado", r: (f) => <span className={`badge-soft-${ESTADO[f.estado]}`}>{f.estado}</span> },
            ]} />
          </Tarjeta>
        </div>
      </>}
    </Pagina>
  );
}
export default ReporteInventario;
